import React, { useEffect, useRef } from 'react';
import { BoxIndex } from '..';
import { NUMBER_OF_PICKS, STEP } from '../../constants';
import EditorPickHomeItem from './EditorPicksHomeItem';
import styles from './EditorPicksHome.module.scss';

const EditorPicks = ({
  location = {},
  anchorId = 'editor-picks',
  items,
  style,
}) => {
  const [numberOfPicks, setNumberOfPicks] = React.useState(NUMBER_OF_PICKS);
  const [maxWidth, setMaxWidth] = React.useState('696px');
  const isScrolled = useRef(false);

  const itemsWithAsset = items.filter((pick) => !!pick.imageURL);
  const filteredPicks = itemsWithAsset
    ? itemsWithAsset.slice(0, numberOfPicks)
    : [];

  useEffect(() => {
    const handleResize = () => {
      const viewportWidth = document.documentElement.clientWidth;

      if (viewportWidth <= 646) {
        setMaxWidth(`${viewportWidth}px`);
      } else {
        setMaxWidth('696px');
      }
    };

    // Set initial value
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const onShowMorePicks = (e) => {
    e.preventDefault();

    if (itemsWithAsset.length > numberOfPicks) {
      setNumberOfPicks(numberOfPicks + STEP);
    }
  };

  useEffect(() => {
    const { hash } = location;
    const isHashSameAsAnchorId = hash && hash.substring(1) === anchorId;

    if (
      !isScrolled.current &&
      isHashSameAsAnchorId &&
      filteredPicks.length > 0
    ) {
      setTimeout(() => document.getElementById(anchorId).scrollIntoView(), 500);
      isScrolled.current = true;
    }
  }, [filteredPicks.length]);

  if (!filteredPicks || filteredPicks.length <= 0) {
    return null;
  }

  return (
    <BoxIndex
      sectionStyle={{ maxWidth }}
      style={style.BoxIndex}
      title="お知らせ"
      anchorId={anchorId}
      // linkText={items.length > numberOfPicks ? 'もっと見る' : ''}
      linkType="charcoal"
      linkAction={onShowMorePicks}
      titleStyle={styles.title}
      wrapperClassName={styles.editorPicksWrapper}
    >
      <div className={styles.articles}>
        {filteredPicks.map((pick, i) => (
          <>
            <div className={styles.pc}>
              <EditorPickHomeItem
                key={i}
                pick={pick}
                isHeading={false}
                isMobileView={false}
              />
            </div>
            <div className={styles.sp}>
              <EditorPickHomeItem
                key={i}
                pick={pick}
                isHeading={i === 0}
                isMobileView
              />
            </div>
          </>
        ))}
      </div>
    </BoxIndex>
  );
};

export default EditorPicks;
